// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"644":"f0d17ab7","927":"11f1cce0","948":"d9e7c9d5"}[chunkId] + ".chunk.css";
};